function PaymentHistory() {
    return (
      <>
        <div className="font-bold text-lg mb-16">PaymentHistory</div>
      </>
    );
  }
  
  export default PaymentHistory;